// src/api/axios.js

import axios from "axios";
import { API_URL } from "../utils/config.js";

//const envURL = process.env.REACT_APP_API_URL?.trim();
//const dynamicURL = `${window.location.protocol}//${window.location.hostname}:5000`;
const PUBLIC_PATHS = [
  "/login",
  "/register",
  "/forgotpassword",
  "/pendingapproval",
];

const API_BASE_URL = API_URL;

const redirectToLogin = (reason = "expired") => {
  try {
    sessionStorage.setItem("auth:reason", reason);
  } catch {}
  // replace() avoids adding a new history entry
  window.location.replace("/login");
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (r) => r,
  (err) => {
    const is401 = err.response?.status === 401;
    const path = window.location.pathname;
    const PUBLIC = [
      "/login",
      "/register",
      "/forgotpassword",
      "/pendingapproval",
    ];
    const isPublic = PUBLIC.includes(path);

    if (is401 && !isPublic) {
      window.localStorage.removeItem("user");
      redirectToLogin("expired");
    }
    return Promise.reject(err);
  },
);

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const isUnauthorized = error.response?.status === 401;
//     const path = window.location.pathname;
//     const isPublic = PUBLIC_PATHS.includes(path);

//     // Only force-redirect on protected pages
//     if (isUnauthorized && !isPublic) {
//       console.warn('Session expired. Redirecting to login.');
//       window.localStorage.removeItem('user');
//       window.location.href = '/login?expired=true';
//     }
//     return Promise.reject(error);
//   },
// );

export default axiosInstance;
